<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-input-group
					placeholder="getMessage_('MWCC000538')"
					:label="getMessage_('MWCC000538')"
					:inputValue="searchParams.tableName"
					:onChange="value => onChangeSearchParam_({ key: 'tableName', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('QWCC000908')"
					:inputValue="searchParams.tbComment"
					:onChange="value => onChangeSearchParam_({ key: 'tbComment', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('QWCC000909')"
					:inputValue="searchParams.colName"
					:onChange="value => onChangeSearchParam_({ key: 'colName', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('MWPRS00072')"
					:inputValue="searchParams.colComment"
					:onChange="value => onChangeSearchParam_({ key: 'colComment', value })"
				>
					<i class="icon-sf-search search-icon">tttt</i>
				</sf-input-group>
			</el-col>
			<!--
			<el-input placeholder="Please input" v-model="input3" class="input-with-select">
				<el-button slot="append" icon="el-icon-search"></el-button>
			</el-input>
-->
			<!-- <el-col :span="4">
				<sf-select-group
					:label="getMessage_('MWCC000145')"
					:inputValue="searchParams.useYn"
					:options="useYnOptions"
					:onChange="value => onChangeSearchParam({ key: 'useYn', value })"
				/>
			</el-col> -->

			<el-col :span="4">
				<span class="sf-input-group-wrapper__label">{{ titles.label }}</span>
				<div class="search-option-wrapper__normal">
					<el-input
						v-model="searchUserPopParams.userName"
						@change="value => onChangeUserPopupSearchParam_({ key: 'userName', value })"
						clearable
					></el-input>
					<i class="icon-sf-search search-icon" @click="onUserPopup"></i>
				</div>
			</el-col>

			<el-col :span="4">
				<span class="sf-input-group-wrapper__label">{{ titles.label2 }}</span>
				<div class="search-option-wrapper__normal">
					<el-input v-model="searchPartParams.partName"></el-input>
					<i class="icon-sf-search search-icon" @click="onPartPopup"></i>
				</div>
			</el-col>
		</el-row>
		<!-- -->
		<template slot="button">
			<!-- <sf-button slot="append" color="info" icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="onUserPopup"></sf-button> -->
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="onClickSearch">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/TableInfo/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		//console.log('SearchView의 created 시작');
		this.$sf_toggleLoading(true);
		Promise.all([this.searchCommCd_({ commCdType: 'USE_YN', init: [] }), this.searchCommCdTypeOptions_()])
			.then(([r]) => {
				this.setUseYnOptions_(r);
			})
			.finally(() => this.$sf_toggleLoading(false));
		//console.log('SearchView의 created 종료');
	},
	data() {
		return {
			titles: {
				label: '사용자명/아이디',
				label2: '부품찾기'
			},
			searchPartParams: {
				partName: '',
				partNo: ''
			}
		};
	},
	methods: {
		...serviceMethods,
		onClickSearch() {
			this.$sf_toggleLoading(true);
			this.select_().finally(() => this.$sf_toggleLoading(false));
		},
		onChangeSearchParam({ key, value }) {
			this.$sf_toggleLoading(true);
			this.onChangeSearchParam_({ key, value })
				.then(() => this.$store.dispatch('tableInfoStore/select_'))
				.finally(() => this.$sf_toggleLoading(false));
		},
		onUserPopup() {
			this.$emit('PopupOpen', this.searchUserPopParams);
		},
		onPartPopup() {
			this.$emit('PqPartPopupOpen', this.searchPartParams);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style>
/* .el-select .el-input {
	width: 110px;
} */
/* .input-with-select .el-input-group__prepend {
	background-color: #fff;
} */
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
}
</style>
